import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MotifTabControl from '@ey/motif-react-wrapper/TabControl';

import StyledMotifTabNavigation from './StyledMotifTabNavigation';
import StyledTabNavigation from './StyledTabNavigation';

const TabNavigation = ({tabs = null, activeTab = null, setTab = null, customSideContent = null, ...rest}) => {
	const filterVisible = ({visible}) => visible !== false;

	const renderTab = (tab) => {
		const {id: key, label: title} = tab;
		const props = {
			key,
			title,
			children: title,
			className: classNames({['motif-active']: activeTab?.id === key}),
			onClick: () => setTab && setTab(tab)
		};
		return <MotifTabControl {...props} />;
	};

	return (
		<StyledTabNavigation>
			<StyledMotifTabNavigation {...rest}>{tabs && tabs.filter(filterVisible).map(renderTab)}</StyledMotifTabNavigation>
			{customSideContent && <aside>{customSideContent()}</aside>}
		</StyledTabNavigation>
	);
};

const tabShape = PropTypes.shape({
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	label: PropTypes.string.isRequired
});

TabNavigation.propTypes = {
	tabs: PropTypes.arrayOf(tabShape),
	activeTab: tabShape,
	setTab: PropTypes.func,
	customSideContent: PropTypes.func
};

export default TabNavigation;
